import React from 'react';
import { Button, notification } from 'antd';

// A new service worker waits until every app window is closed, which rarely
// happens for the installed home-screen app. Offer a reload that activates it.

const NOTIFICATION_KEY = 'app-update-available';
let reloading = false;

const activateUpdate = (registration) => {
  const waiting = registration.waiting;
  if (!waiting) {
    window.location.reload();
    return;
  }
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (reloading) return;
    reloading = true;
    window.location.reload();
  });
  waiting.postMessage({ type: 'SKIP_WAITING' });
};

export const onServiceWorkerUpdate = (registration) => {
  notification.info({
    key: NOTIFICATION_KEY,
    message: 'Update available',
    description: 'A new version of the app is ready.',
    duration: 0,
    btn: (
      <Button type='primary' size='small' onClick={() => activateUpdate(registration)}>
        Reload
      </Button>
    ),
  });
};
